import smallTitle from '../../imgs/small_title.png';
import styles from './index.module.scss';

interface SectionHeaderProps {
  title: string;
}

const SectionHeader = ({ title }: SectionHeaderProps) => (
  <div className={styles.header}>
    <img className={styles.decoration} src={smallTitle} alt="" aria-hidden="true" />
    <span>{title}</span>
  </div>
);

export default SectionHeader;
